(function() {
  document.addEventListener("DOMContentLoaded", () => {
    const backInStockForms = document.querySelectorAll(".back-in-stock form");
    const successPostedMessage = window.backInStockString.success_posted_message || "You subscribed successfully";
    const successMessageColor = "#22bb33";
    const errorPostedMessage = window.backInStockString.error_posted_message || "Something going wrong, try again in a minute";
    const errorVariantMessage = window.backInStockString.error_variant_message || "Select unavailable variant for subscribe";
    const errorMessageColor = "#bb2124";

    backInStockForms.forEach(form => {
      form.addEventListener("submit", (e) => {
        e.preventDefault();

        const formMessage = form.querySelector(".bis__message");
        const currentVariant = document.querySelector("product-form input[name='id']").value;
        const productSubmitButton = document.getElementById("ProductSubmitButton");

        if (productSubmitButton && !productSubmitButton.classList.contains("sold-out")) {
          formMessage.innerHTML = errorVariantMessage;
          formMessage.style.color = errorMessageColor;
          return;
        }

        const email = form.querySelector("input[type='email']").value;
        const userLogged = form.closest(".back-in-stock").dataset.logged === 'true';
        const wishlistButton = document.querySelector(".iWishAdd");

        fetch("https://a.klaviyo.com/api/v1/catalog/subscribe", {
          "headers": {
            "accept": "application/json, text/plain, */*",
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Access-Control-Allow-Origin": "*"
          },
          "mode": "no-cors",
          "body": new URLSearchParams({
            "a": "WceGd9",
            "email": email,
            "platform": "shopify",
            "variant": currentVariant,
            "accept_marketing": true
          }),
          "method": "POST"
        }).then(res => {
          formMessage.innerHTML = successPostedMessage;
          formMessage.style.color = successMessageColor;

          if (userLogged && wishlistButton) wishlistButton.click();
        }).catch(err => {
          formMessage.innerHTML = errorPostedMessage;
          formMessage.style.color = errorMessageColor;
        });
      })
    })
  })
})()
